module.exports = __webpack_public_path__ + "img/camera.147e9ef6.svg";